import UIScreen from './UIScreen';

export default UIScreen;
